<!--
 * @FileDescription: 面包屑（注释描述）
 * @Author: ryb（作者）
 * @Date: 2020-04-13（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-05-13（最后更新时间）
 -->
<template>
    <div class="content-breadcrumb" id="breadcrumb">
        <Contextmenu :itemList="menuItemList" :visible.sync="menuVisible" style="z-index: 9999;" @select="onMenuSelect"></Contextmenu>
        <a-tabs @contextmenu.native="e => onContextmenu(e)" :active-key="activePage" class="tab-layout-tabs" :hide-add="true" type="editable-card" @change="changePage" @tabClick="tabCallBack" @edit="editPage">
            <a-tab-pane :id="page.fullPath" :key="page.fullPath" v-for="page in pageList">
                <span slot="tab" :pagekey="page.fullPath">
                    {{ page.meta.title }}
                    <span class="tab-layout-circle" v-if="page.meta.title != '系统首页'"></span>
                </span>
            </a-tab-pane>
        </a-tabs>
        <!-- 取消退出 -->
        <cancel-out ref="cancelout"></cancel-out>
    </div>

</template>
<script>
    import { triggerWindowResizeEvent } from "@/utils/utils";
    import Contextmenu from './Contextmenu'
    import cancelOut from '@/components/module/cancelOut.vue'
    const indexKey = '/systemoverview/overview/home'

    export default {
        name: "breadcrumb",
        data () {
            return {
                isFour: false,
                pageList: [],
                linkList: [],
                activePage: '',
                menuVisible: false,
                menuItemList: [
                    { key: '4', icon: 'reload', text: '刷 新' },
                    { key: '1', icon: 'arrow-left', text: '关闭左侧' },
                    { key: '2', icon: 'arrow-right', text: '关闭右侧' },
                    { key: '3', icon: 'close', text: '关闭其它' }
                ],
                reloadFlag: true,
            }
        },
        components: {
            Contextmenu,
            cancelOut
        },
        computed: {
            listData () {
                return this.$store.state.closePath
            }
        },
        mounted () {

        },
        created () {
            if (this.$route.path != indexKey) {
                this.addIndexToFirst()
            }
            // update-begin-author:sunjianlei date:20191223 for: 修复刷新后菜单Tab名字显示异常
            // let storeKey = 'route:title:' + this.$route.fullPath
            // let routeTitle = this.$ls.get(storeKey)
            // if (routeTitle) {
            //     this.$route.meta.title = routeTitle
            // }
            // update-end-author:sunjianlei date:20191223 for: 修复刷新后菜单Tab名字显示异常
            this.pageList.push(this.$route)
            this.linkList.push(this.$route.fullPath)
            this.activePage = this.$route.fullPath
            // console.log(this.pageList,this.linkList,this.activePage,'路由')
        },
        methods: {
            /**
             * @description: 确保首页在最前面（方法描述）
             */
            addIndexToFirst () {
                this.pageList.splice(0, 0, {
                    path: indexKey,
                    fullPath: indexKey,
                    meta: {
                        icon: "home",
                        name: "系统首页",
                        route_flag: "1",
                        title: "系统首页",
                    }
                })
                this.linkList.splice(0, 0, indexKey)
            },
            /**
             * @description: route切换（方法描述）
             */
            changePage (key) {
                this.activePage = key
                this.$store.state.loadFailed = false
            },
            /**
             * @description: window刷新（方法描述）
             */
            tabCallBack () {
                this.$nextTick(() => {
                    triggerWindowResizeEvent()
                })
            },
            /**
             * @description: tab切换（方法描述）
             */
            editPage (key, action) {
                this[action](key)
            },
            /**
             * @description: 最上面标题（方法描述）
             */
            changeTitle (title) {
                // 首页特殊处理
                if (this.$route.path === indexKey) {
                    document.title = '首页'
                } else {
                    document.title = title
                }
            },
            /**
             * @description: tab删除某一项（方法描述）
             */
            remove (key) {
                let isClosed = true
                let closedList = this.$store.state.closedList
                closedList.map((item, index) => {
                    if (item == this.$route.path) {
                        isClosed = false
                        this.$refs.cancelout.show()
                    }
                })
                if (isClosed) {
                    if (key == indexKey) {
                        this.$message.warning('首页不能关闭!')
                        return
                    }
                    if (this.pageList.length === 1) {
                        this.$message.warning('这是最后一页，不能再关闭了啦')
                        return
                    }
                    this.pageList = this.pageList.filter(item => item.fullPath !== key)
                    let index = this.linkList.indexOf(key)
                    this.linkList = this.linkList.filter(item => item !== key)
                    index = index >= this.linkList.length ? this.linkList.length - 1 : index
                    this.activePage = this.linkList[index]
                }
            },
            /**
             * @description: 面包屑右键打开（方法描述）
             */
            onMenuSelect (key, target) {
                console.log(key)
                let pageKey = this.getPageKey(target)
                switch (key) {
                    case '1':
                        this.closeLeft(pageKey)
                        break
                    case '2':
                        this.closeRight(pageKey)
                        break
                    case '3':
                        this.closeOthers(pageKey)
                        break
                    case '4':
                        this.routeReload()
                        break
                    default:
                        break
                }
            },
            /**
             * @description: 面包屑右键打开（方法描述）
             */
            getPageKey (target, depth) {
                depth = depth || 0
                if (depth > 2) {
                    return null
                }
                let pageKey = target.getAttribute('pagekey')
                pageKey = pageKey || (target.previousElementSibling ? target.previousElementSibling.getAttribute('pagekey') : null)
                return pageKey || (target.firstElementChild ? this.getPageKey(target.firstElementChild, ++depth) : null)
            },
            /**
             * @description: 面包屑右键关闭左侧（方法描述）
             */
            closeLeft (pageKey) {
                if (pageKey == indexKey) {
                    return
                }
                let tempList = [...this.pageList]
                let indexContent = tempList.slice(0, 1)[0]
                let index = this.linkList.indexOf(pageKey)
                this.linkList = this.linkList.slice(index)
                this.pageList = this.pageList.slice(index)
                this.linkList.unshift(indexContent.fullPath)
                this.pageList.unshift(indexContent)
                if (this.linkList.indexOf(this.activePage) < 0) {
                    this.activePage = this.linkList[0]
                }
            },
            /**
             * @description: 面包屑右键关闭右侧（方法描述）
             */
            closeRight (pageKey) {
                let index = this.linkList.indexOf(pageKey)
                this.linkList = this.linkList.slice(0, index + 1)
                this.pageList = this.pageList.slice(0, index + 1)
                if (this.linkList.indexOf(this.activePage < 0)) {
                    this.activePage = this.linkList[this.linkList.length - 1]
                }
            },
            /**
             * @description: 面包屑右键关闭其他（方法描述）
             */
            closeOthers (pageKey) {
                let index = this.linkList.indexOf(pageKey)
                if (pageKey == indexKey || pageKey.indexOf('?ticke=') >= 0) {
                    this.linkList = this.linkList.slice(index, index + 1)
                    this.pageList = this.pageList.slice(index, index + 1)
                    this.activePage = this.linkList[0]
                } else {
                    let indexContent = this.pageList.slice(0, 1)[0]
                    this.linkList = this.linkList.slice(index, index + 1)
                    this.pageList = this.pageList.slice(index, index + 1)
                    this.linkList.unshift(indexContent.fullPath)
                    this.pageList.unshift(indexContent)
                    this.activePage = this.linkList[1]
                }
            },
            /**
             * @description: 面包屑右键路由刷新（方法描述）
             */
            routeReload () {
                this.$store.dispatch('setIsRouterFlow',false)
                this.$nextTick(() => {
                    this.$store.dispatch('setIsRouterFlow',true)
                })
            },

            onContextmenu (e) {
                const pagekey = this.getPageKey(e.target)
                if (pagekey !== null) {
                    e.preventDefault()
                    this.menuVisible = true
                }
            },
        },
        watch: {
            '$route': function (newRoute) {
                // console.log(newRoute.meta)
                // if(!newRoute.meta.isMenu){
                //     return;
                // }
                this.activePage = newRoute.fullPath
                if (indexKey == newRoute.fullPath) {
                    if (newRoute.meta.keepAlive == false) {
                        //刷新
                    }
                } else if (this.linkList.indexOf(newRoute.fullPath) < 0) {

                    this.linkList.push(newRoute.fullPath)
                    this.pageList.push(Object.assign({}, newRoute))
                    // console.log(this.pageList,'33')
                    if (newRoute.meta.keepAlive) {
                        //刷新
                    }
                } else if (this.linkList.indexOf(newRoute.fullPath) >= 0) {
                    let oldIndex = this.linkList.indexOf(newRoute.fullPath)
                    let oldPositionRoute = this.pageList[oldIndex]
                    this.pageList.splice(oldIndex, 1, Object.assign({}, newRoute, { meta: oldPositionRoute.meta }))
                }
                this.$store.state.keepAlive = ''
                this.pageList.map((item,index) =>{
                    this.$store.state.keepAlive+= item.path.split('/').pop()+ ','
                })
            },
            'activePage': function (key) {
                let index = this.linkList.lastIndexOf(key)
                let waitRouter = this.pageList[index]
                this.$router.push(Object.assign({}, waitRouter));
                if (waitRouter.meta.route_flag == '1') {
                    this.changeTitle(waitRouter.meta.title)
                }
            },
            device () {
                if (this.linkList.indexOf(indexKey) === -1) {
                    this.addIndexToFirst()
                }
            },
            '$store.state.closePath': function (newFlag, oldFlag) {
                this.pageList.map((item, index) => {
                    if (this.$store.state.closePath == item.fullPath) {
                        this.pageList.splice(index, 1)
                    }
                })
                this.linkList.map((item, index) => {
                    if (this.$store.state.closePath == item) {
                        this.linkList.splice(index, 1)
                        this.activePage = this.linkList[index - 1]
                    }
                })
                this.$store.state.closePath = ''
            }
        }
    }
</script>

<style lang="scss">
    .content-breadcrumb {
        margin-left: 20px;
        .tab-layout-tabs{
            .ant-tabs-tab:first-child{
                .anticon-close{
                    display: none !important;
                }
            }
        }
        .three-list {
            display: inline-block;
            height: 40px;
            line-height: 40px;
        }
        .ant-tabs-bar {
            margin: 0 !important;
        }
        .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
            margin-right: 0;
            background: rgba(250, 250, 250, 1);
            box-shadow: 0px 4px 4px 0px rgba(114, 114, 114, 0.06);
            transition: none !important;
        }
        .ant-tabs-tab:first-child {
            border-radius: 6px 0 0 0 !important;
        }
        .ant-tabs-tab:last-child {
            border-radius: 0 6px 0 0 !important;
        }
        .ant-tabs-tab::before {
            transition: none !important;
        }
        .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-ink-bar {
            visibility: visible;
        }
        .ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
            border: 1px solid transparent;
            border-bottom: 3px solid transparent;
            height: 40px;
            line-height: 40px;
            font-size: 16px;
            padding: 0 14px 0 24px;
        }
        .ant-tabs-tab-active {
            background: #fff !important;
            border-bottom: 3px solid var(--co) !important;
            position: relative;
            border-radius: 6px 6px 0px 0px !important;
        }
        .ant-tabs-card-bar .ant-tabs-ink-bar {
            display: none !important;
        }
        .ant-tabs-close-x {
            color: var(--co) !important;
        }
        .ant-tabs.ant-tabs-card .ant-tabs-tab:hover .ant-tabs-close-x {
            opacity: 1 !important;
        }
        .ant-tabs.ant-tabs-card .ant-tabs-tab .ant-tabs-close-x {
            opacity: 0;
        }
    }
</style>
